export default __webpack_public_path__ + "static/media/eyes-closed-icon.b02606f2.svg";